module.exports = __webpack_public_path__ + "static/media/university-interstate-and-overseas.a71cc213.jpg";